import React from "react";
import { ImageAndCaptionBase, Caption } from "./image-and-caption.styled";
import { ImageAndCaptionSliceFragment } from "../../types/graphql";
import { GatsbyImage } from "gatsby-plugin-image";
import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type IImageAndCaptionProps = Slice<
  SharedSliceType.image_and_caption,
  ImageAndCaptionSliceFragment["primary"]
> & { type: SharedSliceType.image_and_caption };

const ImageAndCaption = ({
  slice,
  context,
}: SliceComponentProps<IImageAndCaptionProps, IPageContext>) => {
  const imageAndCaption = slice.primary;
  return (
    (imageAndCaption && (
      <ImageAndCaptionBase>
        {imageAndCaption.image?.gatsbyImageData && (
          <GatsbyImage
            image={imageAndCaption?.image?.gatsbyImageData}
            alt={imageAndCaption?.image?.alt || "Xometry Image"}
          />
        )}
        {imageAndCaption?.caption && (
          <Caption>{imageAndCaption.caption}</Caption>
        )}
      </ImageAndCaptionBase>
    )) || <></>
  );
};

export default ImageAndCaption;
